import React, { useState } from 'react'
import { Spinner, Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import "./ForgetForm.css"
import axios from 'axios';
import { useSelector } from 'react-redux';
import AlertContainer from '../Alert/Alert';

function ForgetForm() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [email, setEmail] = useState('');
  const [show, setShow] = useState(false);
  const [alert, setAlert] = useState('');
  const [loading, setLoading] = useState(false)
      const [msg, setMsg] = useState('');
      const [severity, setSeverity] = useState('');


  const saveData = async (e) => {
    e.preventDefault();
    if (!email) {

      setShow(true)
      setMsg('Please Enter your email')
      setSeverity("error")

    } else {
      setLoading(true)
      await axios
        .post(`https://nanosoft.technology/smile/api/client/forget-password`, {
          email: email,
        })
        .then(async (res) => {
        setShow(true)
      setMsg(currentLocal.language === "English" ? 'Please check your email' : 'يرجى التحقق من البريد الإلكتروني الخاص بك')
      setSeverity("success")
setTimeout(() => {
          setShow(false)

}, 2000);
        })
        .catch((error) => {
          console.log(error.response.data?.message);
          
          setLoading(false)
      setShow(true)
      setMsg(error.response.data?.message)
      setSeverity("error")
setTimeout(() => {
          setShow(false)

}, 1500);

        });

    }

  }
  return (
    <Container>
            {show&&
            <AlertContainer
            msg={msg}
            severity={severity}
            />
      
            }
      <div className='forget_form_container row'>
        <div className='col-md-6 mx-auto mb-4'>
          <h3 className='title mb-2'>
            {currentLocal.home.Recoverpassword}
          </h3>
          <form onSubmit={saveData}>
  
            <div className='mb-2'>
              <label className='mb-1'>{currentLocal.home.emailPlaceholder}
              </label>
              <input
                value={email}
                onChange={(e) => {
                  setShow(false)
                  setEmail(e.target.value)}
                }

              />
            </div>
<Container fluid>
  <Row>
    <Col md={8} className='mt-2'>
                  {currentLocal.home.RememberyourpasswordRecoverpassword}

    </Col>
    <Col md={4}>
                  <Link to="/login" className='forget_link mt-2'>  
               {currentLocal.home.login}</Link>

    </Col>
  </Row>
</Container>

            {/* <div className='w-100 d-flex justify-content-center mb-4'>
              <Link to="/login" className='forget_link'>  
               {currentLocal.home.login}</Link>

            </div> */}

            <button className={loading ? 'disforget_btn d-flex justify-content-center align-items-center mt-4' : 'forget_btn d-flex justify-content-center align-items-center mt-4'} type='submit' disabled={loading && true}>

              {loading &&
                <Spinner animation="border" role="status" className='mx-3' size="sm">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              }
              <p className='mb-0'>

                {currentLocal.home.resetPassword}
              </p>
            </button>
          </form>
        </div>
      </div>
    </Container>)
}

export default ForgetForm